import { graphql } from '@/gql';
import type { GetGroceryEstimationQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getGroceryEstimation = async ({
  planName,
  serviceFee,
  numberOfItems,
  phoneNumber,
  deliveryFee,
  noGoGoFee,
  doNotCharge,
  applyDiscountedFee,
}: GetGroceryEstimationQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      planName,
      serviceFee,
      numberOfItems,
      phoneNumber,
      deliveryFee,
      noGoGoFee,
      doNotCharge,
      applyDiscountedFee,
    },
    query: graphql(`
      query GetGroceryEstimation(
        $planName: PlanName!
        $serviceFee: Float!
        $numberOfItems: Float!
        $phoneNumber: String
        $deliveryFee: Float
        $noGoGoFee: Boolean
        $doNotCharge: Boolean
        $applyDiscountedFee: Boolean
      ) {
        getGroceryEstimation(
          planName: $planName
          serviceFee: $serviceFee
          numberOfItems: $numberOfItems
          phoneNumber: $phoneNumber
          deliveryFee: $deliveryFee
          noGoGoFee: $noGoGoFee
          doNotCharge: $doNotCharge
          applyDiscountedFee: $applyDiscountedFee
        ) {
          serviceFee
          gogoFee
          total
          expiringCredit
          credits
          card
          partnerCosts
        }
      }
    `),
  });

  return response.data.getGroceryEstimation;
};
